export default __webpack_public_path__ + "static/media/NoBidsColorIcon.248d142d.svg";